export default {"src":"/_next/static/media/arrow_tooltip.acbe59d4.svg","height":8,"width":16,"blurWidth":0,"blurHeight":0};